import { mediaQueryWatcher } from '@functions';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

mediaQueryWatcher("(max-width: 991px)", (matches) => {
  mobileSliderView(matches);
});

function mobileSliderView(matches) {
  const sections = document.querySelectorAll('.wp-block-lb-contact-form');

  sections.forEach((section) => {
    const swiperContainer = section.querySelector('.section__contact-persons');
    if (!swiperContainer) return;

    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    if(slides.length <= 1) return;

    if(matches) {
      section.classList.add('is-slider');


      new Swiper(swiperContainer, {
        modules: [Navigation],
        slidesPerView: 1.13,
        spaceBetween: 24,
        loop: true,
        navigation: {
          nextEl: section.querySelector('.section__contact-persons__navigation .swiper-btn-next'),
          prevEl: section.querySelector('.section__contact-persons__navigation .swiper-btn-prev'),
        }
      });

    } else {
      if(section.classList.contains('is-slider')) {
        section.classList.remove('is-slider');
        swiperContainer.swiper.destroy();
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  const sections = document.querySelectorAll('.wp-block-lb-contact-form');

  sections.forEach(function(section) {
    const formColumnContent = section.querySelector('.section__left-column');
    const rightColumn = section.querySelector('.section__right-column');

    const observer = new MutationObserver(function(mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const successAlert = section.querySelector('.gform_confirmation_message');
          if (successAlert) {
            if (formColumnContent) {
              formColumnContent.style.display = 'none';
            }

            if (rightColumn) {
              rightColumn.classList.add('full-width');
            }

            const brs = successAlert.querySelectorAll('br');
            brs.forEach(br => br.remove());

            section.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }
      }
    });

    observer.observe(section, { childList: true, subtree: true });
  });
});
